import { axiosPrivate } from "./axios";

const postOnboardForm = async ({
  integratorId,
  storeId,
  deliveryService,
  isExisting,
  data,
  token,
}) =>
  await axiosPrivate
    .post(
      `/integrator-service/integrators/${integratorId}/stores/${storeId}/onboard-delivery-services`,
      {
        deliveryService,
        isExisting,
        data,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    )
    .then(({ data }) => data);

export default postOnboardForm;
